export const landingPageColors = {
    background: "#11141b",
    backgroundDeep: "#0a1424",
    backgroundSection: "#181d25",
    backgroundSectionAlt: "#151b22",
    text: "#f4f7fb",
    textHighlight: "#dbeafe",
    textPrimaryAccent: "#8cc7ff",
    textSecondaryAccent: "#7df0b3",
    textMuted: "rgba(244,247,251,0.86)",
    textSoft: "rgba(244,247,251,0.82)",
    textSubtle: "rgba(244,247,251,0.8)",
    textSecondary: "rgba(244,247,251,0.78)",
    textTertiary: "rgba(244,247,251,0.72)",
    textQuaternary: "rgba(244,247,251,0.68)",
    borderSoft: "rgba(148, 163, 184, 0.14)",
    borderMedium: "rgba(148, 163, 184, 0.16)",
    borderStrong: "rgba(148, 163, 184, 0.2)",
    borderEmphasis: "rgba(148, 163, 184, 0.18)",
    borderLight: "rgba(255,255,255,0.12)",
    borderButton: "rgba(244,247,251,0.28)",
    borderPrimaryAccent: "rgba(140,199,255,0.16)",
    borderSecondaryAccent: "rgba(35,217,123,0.16)",
    surfaceGlass: "rgba(14, 20, 28, 0.78)",
    surfaceOverlay: "rgba(255,255,255,0.03)",
    surfaceOverlayStrong: "rgba(8,17,29,0.4)",
    surfaceOverlayMuted: "rgba(8,17,29,0.34)",
    surfaceHover: "rgba(244,247,251,0.08)",
    sectionTint: "rgba(255,255,255,0.02)",
    heroGlow: "rgba(86, 105, 125, 0.12)",
    stepBadge: "rgba(43,150,251,0.18)",
    cta: "#24bdf0",
    ctaHover: "#61b1fc",
    heroBackground: "#11141b",
    heroPanelBackground: "linear-gradient(180deg, rgba(11,23,48,0.96) 0%, rgba(8,17,29,0.9) 100%)",
    whyBackground: "linear-gradient(180deg, rgba(32, 44, 59, 0.8) 0%, rgba(17, 25, 35, 0.95) 100%)",
    deploymentBackground: "linear-gradient(135deg, rgba(35,129,217,0.2) 0%, rgba(35,217,123,0.12) 100%)",
    heroShadow: "0 40px 120px rgba(0, 0, 0, 0.38)",
} as const